import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget, FiUsers, FiHeart, FiUser } = FiIcons;

const About = () => {
  const features = [
    {
      icon: FiTarget,
      title: "Yin Yoga",
      description: "Sanfte Dehnungen lösen Spannungen und öffnen den Körper behutsam."
    },
    {
      icon: FiHeart,
      title: "Klang",
      description: "Klänge beruhigen dein Nervensystem und fördern tiefe Entspannung."
    },
    {
      icon: FiUsers,
      title: "Kleine Gruppe",
      description: "Maximal 4 Teilnehmende – jeder wird gesehen und gehalten."
    },
    {
      icon: FiUser,
      title: "Zwei Expertinnen",
      description: "Nadine (Yin Yoga) und Marcella (Klang) begleiten dich gemeinsam."
    }
  ];

  return (
    <section id="about" className="py-16" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-serif mb-8" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
            Yin und Klang – Entspannung, die wirkt
          </h2>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>
            In Kassel entsteht ein Raum für tiefe Ruhe.<br />
            Sanfte Dehnungen aus dem Yin Yoga öffnen den Körper.<br />
            Klänge aus Klangschalen beruhigen das Nervensystem.<br /><br />
            Beides zusammen führt zu einem Zustand, in dem dein Geist klarer wird und dein Körper regenerieren kann.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Room Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759846903651-blob" 
              alt="Heller Yogaraum mit Matten und Klangschalen" 
              className="w-full h-auto rounded-2xl shadow-lg"
            />
          </motion.div>

          {/* Features with Icons */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex flex-col justify-center"
          >
            <div className="grid grid-cols-1 gap-8">
              {features.map((feature, index) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.02, x: 10 }}
                  className="p-6 rounded-2xl shadow-lg border"
                  style={{ backgroundColor: '#FFFFFF', borderColor: '#CBB8A9' }}
                >
                  <div className="flex items-start">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 flex-shrink-0" style={{ backgroundColor: '#CBB8A9' }}>
                      <SafeIcon icon={feature.icon} className="w-6 h-6" style={{ color: '#314C40' }} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>{feature.title}</h3>
                      <p className="leading-relaxed" style={{ fontFamily: 'Lato, sans-serif', color: '#2C2C2C' }}>{feature.description}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Testimonial Tile */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="p-8 rounded-2xl shadow-lg border max-w-4xl mx-auto"
          style={{ backgroundColor: '#F9F5F0', borderColor: '#CBB8A9' }}
        >
          <div className="text-center">
            <p className="text-stone-800 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
              <span className="block font-semibold mb-3 text-lg" style={{ fontFamily: 'Libre Baskerville, serif', color: '#314C40' }}>
                Julia Beer, Teilnehmerin:
              </span>
              <span className="italic text-base" style={{ color: '#2C2C2C' }}>
                „Ich war zu diesem Zeitpunkt sehr gestresst, gereizt und innerlich angespannt. Schon nach kurzer Zeit habe ich gemerkt, wie mein Nervensystem deutlich zur Ruhe kam. Die Kombination aus Yin Yoga und Klangschalen war unglaublich wohltuend und nachhaltig beruhigend. Danach ging es mir spürbar besser – körperlich wie mental.“
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;